import { useContext, useEffect, useState } from "react";
import ContentPage from "../../Content";
import moment from "moment";
import CustomerStyle from "../../../utils/customerStyle";
import BaseUrl from "../../../utils/BaseUrl";
import axios from "axios";
import separateNumber from "../../../utils/separateur";
import ExportExcel from "../../../utils/ExcelExport";
import { UserContext } from "../../../utils/User_check";
import can from "../../../utils/Can";
import { useNavigate } from "react-router-dom";


const url = BaseUrl();
const customerStyle = CustomerStyle();
function Approvisionnement(){
    const [dateTime,setDateTime] = useState(new Date()) ;
    const [itemsList,setItemsList] = useState([]);
    const [itemsListFilter,setItemsListFilter] = useState([]);
    const [loading, setLoading] = useState(false);
    const [dateDebut,setDateDebut] = useState('');
    const [dateFin,setDateFin] = useState('');

    const {user,role, permissions} = useContext(UserContext);
    const navigate = useNavigate();
    useEffect(()=>{
      if(user && permissions && !can(permissions,'PAGE APPROVISIONNEMENT')){
          navigate('/page-no-found');
      }
    },[user]);

    useEffect(()=>{
        fetchData(dateTime);
    },[]);

    const fetchData = async (date_debut,date_fin) => {
        try {

            // const _formData = new FormData();
            // _formData.append('datevente',moment(dateTime).format('YYYY-MM-DD'));

            // console.log(_formData);
            setLoading(true);
            // Remplacez par l'URL réelle de votre API
            const response = await axios.post(url.base+'/approvisionnements',{date_debut:moment(date_debut).format('YYYY-MM-DD'),date_fin:moment(date_fin).format('YYYY-MM-DD')},{
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                }});
            const data = response.data.data;

            // Transforme les données pour utiliser le nom comme clé et ajoute la somme des ventes
            const transformedData = {};
            Object.values(data).forEach((sales) => {
                sales.forEach((sale) => {
                    const sellerName = sale.NomCommercial || 'Inconnu';
                    if (!transformedData[sellerName]) {
                        transformedData[sellerName] = {
                            sales: [],
                            totalSales: 0,
                        };
                    }
                    transformedData[sellerName].sales.push(sale);
                    transformedData[sellerName].totalSales += sale.Montant;
                });
            });

            setItemsList(transformedData);
            setItemsListFilter(transformedData);
            setLoading(false);
        } catch (err) {
            setLoading(false);
        }
    };

    const sortedData = Object.entries(itemsListFilter).sort(
        ([, a], [, b]) => b.totalSales - a.totalSales
      );


    const handleFilter = (event) => {
        const searchValue = event.target.value.toLowerCase();
        const filtered = Object.keys(itemsList).reduce((result, sellerName) => {
          if (sellerName.toLowerCase().includes(searchValue)) {
            result[sellerName] = itemsList[sellerName];
          }
          return result;
        }, {});
    
        setItemsListFilter(filtered);
      };

      const handleFilterDate=(event)=>{
        const dateValue = event.target.value;
        if(event.target.value !== ""){
            setDateTime(dateValue);
            setDateFin(dateValue)
            fetchData(dateDebut,dateValue);
        }

        
      }
    

    return (
        <>
            <ContentPage>
            <div class="page-header flex-wrap">
            <div class="header-right d-flex flex-wrap mt-md-2 mt-lg-0">
                <div class="d-flex align-items-center">
                  <a href="#">
                    <p class="m-0 pr-3">Page</p>
                  </a>
                  <a class="pl-3 mr-4" href="#">
                    <p class="m-0">Approvisionnements</p>
                  </a>
                </div>
                
              </div>
              <div class="header-left">
                {/* <Link class="btn btn-primary mb-2 mb-md-0 mr-2" to="/parametres/add-commercial"> Ajouter un commercial</Link> */}
                {/* <button class="btn btn-outline-primary mb-2 mb-md-0"> Import documents </button> */}
              </div>
              
            </div>

            <div class="col-lg-12 grid-margin stretch-card">
            <div class="card">
            <div class="card-header bg-warning bg-gradient">
                      <div class="row">
                          <div class=" col-lg-3 col-md-3">
                              <input type="search" class="form-control " placeholder="Recherche un commercial..." onChange={handleFilter}/>
                          </div>

                          <div class=" col-lg-3 col-md-3">
                              <input type="date" class="form-control"  onChange={(e)=>setDateDebut(e.target.value)}/>
                          </div>
                          <div class=" col-lg-3 col-md-3">
                              <input type="date" class="form-control"  onChange={handleFilterDate}/>
                          </div>

                          <div class=" col-lg-3 col-md-3">
                            {/* <ExportExcel excelData={itemsListFilter} filename={"LISTE DES APPROVISIONNEMENTS DES COMMERCIAUX"}  title={"Télécharger"}/> */}
                          </div>
                  </div>
              </div>
                <h2 className="text-center">LISTE DES APPROS DU   { dateFin =='' ? moment(dateTime).format('DD-MM-YYYY') : `${moment(dateDebut).format('DD-MM-YYYY')} AU ${moment(dateFin).format('DD-MM-YYYY')}`}</h2>

                {loading &&
                <div class="text-center">
                <div class="spinner-border" role="status">
                  {/* <span class="visually-hidden">Loading...</span> */}
                </div>
              </div>
                }

               
                  <div class="accordion p-3" id="accordionExample">
                  {!loading && Object.keys(sortedData).length > 0 ?
                  
                  sortedData.map(([sellerName, sellerData],order)  => (
                  <>

                 
                  <div class="accordion-item p-3">
                    <h2 class="accordion-header" id={`headingOne${order+1}`}>
                      <button class="accordion-button fw-bold" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseOne${order+1}`} aria-expanded="true" aria-controls={`collapseOne${order+1}`}>
                      {order+1} - {sellerName}
                      </button>
                    </h2>
                    <div id={`collapseOne${order+1}`} class="accordion-collapse collapse" aria-labelledby={`headingOne${order+1}`} data-bs-parent="#accordionExample">
                      <div class="accordion-body">
                      <p><strong>Total des appros : </strong><b className="text-success">{ separateNumber(sellerData.totalSales) } FCFA</b></p>
                      <div class="table-responsive">
                        <table class="table table-striped">
                          <thead> 
                            <tr>
                              <th>ID</th>
                              <th>DATE</th>
                              <th>TERRITOIRE</th>
                              <th>SECTEUR</th>
                              <th  className="text-center">PRODUIT</th>
                              <th  className="text-center">MONTANT</th>
                              <th>N° MARCHAND POS</th>
                            </tr>
                          </thead>
                          <tbody>
                          {sellerData.sales.map((vente, index) => (
                            <tr key={index}>
                              <td class="py-1">
                                <img src="../../../assets/images/faces-clipart/pic-1.png" alt="image"/>
                              </td>
                              <td>{moment(vente.DateVente).format('Do MMMM YYYY')}</td>
                              <td>
                                {vente.NomTerritoire}
                              </td>
                              <td>
                                {vente.NomSecteur}
                              </td>
                              <td className="text-center">
                                {vente.NomProduit}
                              </td>
                              <td className="text-center">
                                  <b className={vente.Montant > 100000 ? "text-danger" : "text-success"}>{separateNumber(vente.Montant)  }</b>
                              </td>                            
                              <td>{vente.NumeroMarchandPOS}</td>
                            </tr>
                          ))}
                          </tbody>
                        </table>
                      </div>
                      </div>
                    </div>
                  </div>
               
               
                    {/* <div class="card-body pb-3 border" key={sellerName}>
                      <h4 class="card-title">{order+1}-{sellerName}</h4>
                      <p><strong>Total des appros : </strong><b className="text-success">{ separateNumber(sellerData.totalSales) } FCFA</b></p>
                      <div class="table-responsive">
                        <table class="table table-striped">
                          <thead> 
                            <tr>
                              <th>ID</th>
                              <th>DATE</th>
                              <th>TERRITOIRE</th>
                              <th>SECTEUR</th>
                              <th  className="text-center">PRODUIT</th>
                              <th  className="text-center">MONTANT</th>
                              <th>N° MARCHAND POS</th>
                            </tr>
                          </thead>
                          <tbody>
                          {sellerData.sales.map((vente, index) => (
                            <tr key={index}>
                              <td class="py-1">
                                <img src="../../../assets/images/faces-clipart/pic-1.png" alt="image"/>
                              </td>
                              <td>{moment(vente.DateVente).format('Do MMMM YYYY')}</td>
                              <td>
                                {vente.NomTerritoire}
                              </td>
                              <td>
                                {vente.NomSecteur}
                              </td>
                              <td className="text-center">
                                {vente.NomProduit}
                              </td>
                              <td className="text-center">
                                  <b className={vente.Montant > 100000 ? "text-danger" : "text-success"}>{separateNumber(vente.Montant)  }</b>
                              </td>                            
                              <td>{vente.NumeroMarchandPOS}</td>
                            </tr>
                          ))}
                          </tbody>
                        </table>
                      </div>
                    </div> */}

                  </>
               )) :   (!loading && <p>Aucun commercial trouvé.</p>)}
                </div>
                </div>
              </div>
            </ContentPage>
        </>
    )
}

export default Approvisionnement;